module.exports = __webpack_public_path__ + "img/profile.01a7d1b0.svg";